import { render } from "./portefeuille.vue?vue&type=template&id=158e76b7"
import script from "./portefeuille.vue?vue&type=script&lang=js"
export * from "./portefeuille.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__